import {
  ReviewedDocumentationFactory,
  ReviewedDocumentationFactoryError,
  ReviewedDocumentation,
  GeneralDocumentationData,
  ProcedureInternalId,
  BatchInternalId,
  MadeiristaId
} from '@/Domain/ReviewedDocumentation'
import { AxiosReviewedDocumentationData } from './AxiosReviewedDocumentationData'
import { AxiosFileInfo } from './AxiosFileInfo'
import {
  FileInfo,
  DocumentId,
  FileName,
  RejectionReason,
  FileInfoStatus,
  FileInfoType
} from '@/Domain/ReviewedDocumentation/FileInfo'
import { AxiosGeneralData } from './AxiosGeneralData'
import { ProcedureId } from '@/Domain/Procedures'

export class AxiosReviewedDocumentationFactory implements ReviewedDocumentationFactory<AxiosReviewedDocumentationData> {
  makeReviewedDocumentation (data: AxiosReviewedDocumentationData): ReviewedDocumentation {
    try {
      const fileInfos = this.parseFileInfos(data.archivos)
      const generalData = this.parseGeneralData(data.generalData)
      return new ReviewedDocumentation(generalData, fileInfos)
    } catch (error) {
      throw new ReviewedDocumentationFactoryError(error.message)
    }
  }

  private parseGeneralData (data: AxiosGeneralData): GeneralDocumentationData {
    return new GeneralDocumentationData(
      new ProcedureId(data.procedureCode),
      new ProcedureInternalId(parseInt(data.procedureId, 10)),
      new BatchInternalId(parseInt(data.expedienteId, 10)),
      new MadeiristaId(parseInt(data.madeiristaId, 10))
    )
  }

  private parseFileInfos (data: AxiosFileInfo[]): FileInfo[] {
    const result: FileInfo[] = []
    for (const fileInfo of data) {
      result.push(this.parseSingleFileInfo(fileInfo))
    }
    return result
  }

  private parseSingleFileInfo (fileInfo: AxiosFileInfo): FileInfo {
    const rejectionReason = fileInfo.reasonRejection === null ? '-' : fileInfo.reasonRejection
    return new FileInfo(
      new DocumentId(parseInt(fileInfo.documentId, 10)),
      new FileName(fileInfo.fileName),
      new RejectionReason(rejectionReason),
      fileInfo.estado as FileInfoStatus,
      fileInfo.typeCode as FileInfoType
    )
  }
}
